import  gql  from 'graphql-tag'

export const CREATE_FINANCIAL_ASSESSMENT = gql`mutation createFinancialAssessment($input: FinancialAssessmentInput!){
    createFinancialAssessment(input: $input){
        errors{
            field
            messages
        }
        assessment {
            fm102{
                id
            }
            id
            status
            createdAt
            debtor{
                fm100{
                    id
                }
                id
                creditstudySet{
                    edges{
                        node{
                            id
                            productType{
                                id
                            }
                        }
                    }
                }
                person{
                    id
                    fullName
                    identificationNumber
                }
                spouse{
                    person{
                        id
                    }
                    creditstudy{
                        id
                    }
                }
            }
            codebtorSet{
                edges{
                node{
                    id
                    fm100{
                        id
                    }
                    creditstudySet{
                    edges{
                        node{
                            id
                            productType{
                                id
                            }
                        }
                    }
                    }
                    person{
                    id
                    fullName
                    identificationNumber
                    }
                }
                }
            }
        }
    }
}`;